import styled from 'styled-components';
import { Table, Tooltip } from '@dexma/ui-components';

export const StyledSpan = styled.span<{ onClick?: () => void }>`
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;

export const StyledTable = styled(Table)`
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    span {
        margin-bottom: 0 !important;
        font-size: 14px;
        font-weight: normal;
    }
    .ant-table-row {
        height: auto;
    }
    h5,
    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .description-column span,
    .name-column span {
        white-space: normal;
        word-break: break-word;
    }

    .name-column {
        max-width: 200px;
    }

    .ant-table-cell {
        border-bottom: 1px solid #dee0e2 !important;
    }

    .no-padding {
        padding: 0 !important;
    }

    .remove-border::before {
        content: none !important;
    }
    .background-none {
        background: none !important;
    }
`;

export const StyledFlex = styled.div`
    display: flex;
    h5 {
        margin-left: 8px;
    }
    svg {
        min-width: 24px;
        max-width: 24px;
    }
`;

export const StyledSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledPinnedTooltip = styled(Tooltip)`
    .ant-tooltip-inner {
        text-align: center;
    }
`;
